<template><DashboardPanel title="工单处理趋势" meta="单位：单"><div class="work-legend"><span><i class="blue"></i>新增工单</span><span><i class="green"></i>完成工单</span><span><i class="line"></i>平均处理时长（小时）</span></div><div ref="chart" class="work-chart"></div></DashboardPanel></template>
<script>
import * as echarts from 'echarts'
import DashboardPanel from './DashboardPanel.vue'
import { axisScale, dashboardTooltip, formatNumber, roundNumber, toNumber } from '../dashboardFormat'

export default {
  name: 'WorkOrderTrend',
  components: { DashboardPanel },
  props: { data: { type: Object, default: () => ({}) } },
  data: () => ({ chart: null }),
  computed: {
    trend() {
      const rows = Array.isArray(this.data.trend) ? this.data.trend : []
      const grouped = {}
      rows.forEach(row => {
        const bucket = row.bucket || 'unknown'
        const item = grouped[bucket] || { bucket, repairCount: 0, finishedCount: 0, timeoutCount: 0, processingHoursTotal: 0 }
        const count = toNumber(row.repairCount)
        item.repairCount += count
        item.finishedCount += toNumber(row.finishedCount)
        item.timeoutCount += toNumber(row.timeoutCount)
        item.processingHoursTotal = roundNumber(item.processingHoursTotal + (toNumber(row.avgProcessingHours) * count), 4)
        grouped[bucket] = item
      })
      return Object.keys(grouped).sort().map(bucket => {
        const item = grouped[bucket]
        return Object.assign(item, { avgProcessingHours: item.repairCount ? roundNumber(item.processingHoursTotal / item.repairCount, 1) : 0 })
      })
    }
  },
  watch: { data: { deep: true, handler() { this.renderChart() } } },
  mounted() {
    this.renderChart()
    window.addEventListener('resize', this.resizeChart)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeChart)
    if (this.chart) this.chart.dispose()
  },
  methods: {
    renderChart() {
      if (!this.chart) this.chart = echarts.init(this.$refs.chart)
      const total = this.trend.map(item => item.repairCount)
      const finished = this.trend.map(item => item.finishedCount)
      const hours = this.trend.map(item => item.avgProcessingHours)
      const max = Math.max.apply(null, total.concat(finished).concat([1]))
      const countAxis = axisScale(max, 4)
      const maxHours = Math.max.apply(null, hours.concat([0]))
      const hoursAxis = axisScale(maxHours ? maxHours * 1.1 : 1, 4)
      this.chart.setOption({
        grid: { top: 11, right: 36, bottom: 27, left: 39 },
        tooltip: dashboardTooltip({
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          formatter: params => {
            const rows = Array.isArray(params) ? params : [params]
            return [rows[0] ? rows[0].axisValue : ''].concat(rows.map(item => {
              const isHours = item.seriesName === '平均处理时长'
              return `${item.marker}${item.seriesName}：${formatNumber(item.value, isHours ? 1 : 0)} ${isHours ? '小时' : '单'}`
            })).join('<br/>')
          }
        }),
        xAxis: { type: 'category', data: this.trend.map(item => String(item.bucket || '').slice(5)), axisLine: { lineStyle: { color: '#35586e' } }, axisTick: { show: false }, axisLabel: { color: '#9db1bf', fontSize: 10 } },
        yAxis: [{ type: 'value', min: 0, max: countAxis.max, interval: countAxis.interval, axisLabel: { color: '#9db1bf', fontSize: 10 }, splitLine: { lineStyle: { color: 'rgba(67,122,157,.14)', type: 'dashed' } } }, { type: 'value', min: 0, max: hoursAxis.max, interval: hoursAxis.interval, axisLabel: { color: '#9db1bf', fontSize: 10, formatter: value => formatNumber(value, hoursAxis.interval < 1 ? 1 : 0) }, splitLine: { show: false } }],
        series: [{ name: '新增工单', type: 'bar', barWidth: 16, data: total, itemStyle: { color: '#318aee' }, label: { show: true, position: 'top', color: '#d7e4ed', fontSize: 9, formatter: params => formatNumber(params.value) } }, { name: '完成工单', type: 'bar', barWidth: 16, data: finished, itemStyle: { color: '#3bb668' }, label: { show: true, position: 'top', color: '#d7e4ed', fontSize: 9, formatter: params => formatNumber(params.value) } }, { name: '平均处理时长', type: 'line', yAxisIndex: 1, data: hours, symbolSize: 7, lineStyle: { color: '#ffc328', width: 2 }, itemStyle: { color: '#ffc328' }, label: { show: true, position: 'top', distance: 5, color: '#e9edf0', fontSize: 9, formatter: params => formatNumber(params.value, 1) } }]
      }, true)
    },
    resizeChart() { if (this.chart) this.chart.resize() }
  }
}
</script>
<style lang="scss" scoped>.work-legend{position:absolute;z-index:2;top:10px;right:92px;display:flex;gap:24px;color:#9eb2c0;font-size:10px}.work-legend span{display:flex;align-items:center}.work-legend i{display:inline-block;width:10px;height:8px;margin-right:7px}.work-legend .blue{background:#328ced}.work-legend .green{background:#3ab467}.work-legend .line{position:relative;height:2px;background:#ffc329}.work-legend .line::after{position:absolute;top:-3px;left:3px;width:7px;height:7px;border-radius:50%;background:#ffc329;content:''}.work-chart{width:100%;height:100%}</style>
